export default {
  title: "Device permissions needed",
  info_text_1:
    "This app, as so many others, needs a number of permissions in order to function properly.",
  info_text_2: "The app will ask for each of the following permissions in turn.",
  video_title: "Take pictures and record video",
  video_text_1:
    'Adding pictures or videos to the various registry objects (<b class="text-info">Areas, Items, Issues</b>, etc.)',
  video_text_2: "Scanning QR codes ",
  storage_title: "Access device storage",
  storage_text: "Uploading attachments",
  location_title: "Access location information",
  location_text:
    'Enables the automatic highlighting of the nearest <b class="text-info">Workspace</b>, if its coordinates are known.',
}
